import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroMatchingV2Section.ColorBarSection', {
    overflowedAmountText: 'The total of all Bills ({amount}) exceeds the Purchase Order amount ({total})',
});
